import React, { useState } from 'react';
import { DialogV2, AritoIcon, AritoFormV2, BottomActionBarV2 } from '@/components/custom/erp';

import { ProvinceFormattedData, SearchFormValues, searchSchema } from '../../schemas';
import { TinhThanh } from '@/types/schemas';
import ProvinceForm from './ProvinceForm';
import { FormMode } from '@/types/form';

interface ProvinceDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: SearchFormValues;
  onClose: () => void;
  onSubmit?: (data: ProvinceFormattedData) => void;
  selectedObj?: TinhThanh | null;
  updateProvince?: (uuid: string, data: ProvinceFormattedData) => Promise<void>;
  addProvince?: (data: ProvinceFormattedData) => Promise<void>;
  // Additional props for view mode actions
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

function ProvinceDialog({
  open,
  mode,
  initialData,
  onClose,
  onSubmit,
  selectedObj,
  updateProvince,
  addProvince,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: ProvinceDialogProps) {
  const handleSubmit = async (data: SearchFormValues) => {
    const formattedData: ProvinceFormattedData = {
      ma_tinh: data.ma_tinh,
      ten_tinh: data.ten_tinh,
      ten_tinh2: data.ten_tinh2 || null,
      status: data.trang_thai.toString()
    };

    try {
      if (mode === 'edit' && selectedObj && updateProvince) {
        await updateProvince(selectedObj.uuid, formattedData);
      }
      if (mode === 'add' && addProvince) {
        await addProvince(formattedData);
      } else if (onSubmit) {
        onSubmit(formattedData);
      }

      onClose();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };
  const title = mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem';

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={title}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={12} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={searchSchema}
          onSubmit={handleSubmit}
          initialData={initialData}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<ProvinceForm mode={mode} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default ProvinceDialog;
